import { render, staticRenderFns } from "./FeaturesMobile.vue?vue&type=template&id=06a0471a&scoped=true&"
import script from "./FeaturesMobile.vue?vue&type=script&lang=js&"
export * from "./FeaturesMobile.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesMobile.vue?vue&type=style&index=0&id=06a0471a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a0471a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
